import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import * as Parse from 'parse';

@Injectable()
export class EventLogService {

    constructor(private auth: AuthService) {
    }

    createEventLog(customerId: string, propertyId: string) {
        return Parse.Cloud.run('createEventLog', {
            customerId: customerId,
            propertyId: propertyId,
            event: 'viewed-property'
        });
    }

    fetchPropertyActivity(property: Parse.Object, pageIndex: number, pageSize: number) {
        const query: Parse.Query<Parse.Object> = new Parse.Query('EventLog');

        query.limit(pageSize);
        query.skip(pageSize * pageIndex);
        query.equalTo('property', property);
        query.equalTo('organization', property.get('organization'));
        query.descending('createdAt');

        if (this.auth.userType === 'Admin') {
            // Admins will see all entries, all customer details
            query.include('customer');
            query.include('preferredAgent');
        } else if (this.auth.userType === 'SA') {
            // SAs will not see pref Agent at all, they only see their customer entries
            query.equalTo('preferredAgent', this.auth.currentUser);
            query.include('customer');
        }

        query.withCount();

        return query.find();
    }

    fetchPropertyActivityAthena(property: Parse.Object, pageIndex: number, pageSize: number) {
        return Parse.Cloud.run('fetchPropertyActivity', {
            propertyId: property.id,
            organizationId: property.get('organization').id,
            pageSize: pageSize,
            pageIndex: pageIndex
        });
    }

    fetchCustomerActivity(customer: Parse.Object, pageIndex: number, pageSize: number) {
        const query: Parse.Query = new Parse.Query('EventLog');

        query.limit(pageSize);
        query.skip(pageSize * pageIndex);
        query.exists('customer');
        query.equalTo('customer', customer);
        query.equalTo('organization', customer.get('organization'));
        query.include('property');
        query.include('customer');
        query.descending('createdAt');

        query.withCount();

        return query.find();
    }

    fetchCustomerOwners(agentIds: string[]) {
        return Parse.Cloud.run('fetchCustomerOwners', { customerIds: agentIds });
    }

    fetchCustomerActivityAthena(customer: Parse.Object, pageIndex: number, pageSize: number) {
        return Parse.Cloud.run('fetchCustomerActivity', {
            customerId: customer.id,
            organizationId: customer.get('organization').id,
            pageSize: pageSize,
            pageIndex: pageIndex
        });
    }

    fetchPropertyActivityCount(property: Parse.Object) {
        return Parse.Cloud.run('fetchPropertyActivityCount', {
            propertyId: property.id,
            organizationId: property.get('organization').id
        });
    }

    fetchCustomerActivityCount(customer: Parse.Object) {
        return Parse.Cloud.run('fetchCustomerActivityCount', {
            customerId: customer.id,
            organizationId: customer.get('organization').id
        });
    }
}
